module.exports = __webpack_public_path__ + "img/lock.b6d2c0f2.svg";